import { render, staticRenderFns } from "./TransferDetails.vue?vue&type=template&id=75e6c31e"
import script from "./TransferDetails.vue?vue&type=script&lang=js"
export * from "./TransferDetails.vue?vue&type=script&lang=js"
import style0 from "./TransferDetails.vue?vue&type=style&index=0&id=75e6c31e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports